import { render, staticRenderFns } from "./FancyOTP.vue?vue&type=template&id=17f95728&"
import script from "./FancyOTP.vue?vue&type=script&lang=js&"
export * from "./FancyOTP.vue?vue&type=script&lang=js&"
import style0 from "./FancyOTP.vue?vue&type=style&index=0&id=17f95728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports